export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/real_estate_promos.f2e66f8.svg";